/**
 * The guided first visit's per-course content: one short narrated slide, the tutor's suggested questions and a
 * two-question quiz for each course (owner 2026-10-09; Sol realbuild1 R1, realjourney Q2). Built and checked by
 * scripts/first-visit-tour/build-tour.mjs and published as one public file next to the unit files.
 */
export const TOUR_URL = 'https://ql-unit-json.s3.us-west-2.amazonaws.com/onboarding/tour-v1.json';

let loading = null;

/** Loads the tour file once per page. A failed load is not cached, so the next call tries again. */
export function loadTour(fetchImpl = typeof fetch === 'function' ? fetch : null) {
  if (!loading) {
    if (!fetchImpl) return Promise.reject(new Error('fetch is not available'));
    loading = fetchImpl(TOUR_URL)
      .then(response => {
        if (!response.ok) throw new Error(`tour file answered ${response.status}`);
        return response.json();
      })
      .then(validTour)
      .catch(error => {
        loading = null;
        throw error;
      });
  }
  return loading;
}

/** Forgets the cached file (tests). */
export function resetTourCache() {
  loading = null;
}

function validTour(doc) {
  if (!doc || doc.version !== 1 || typeof doc.courses !== 'object' || typeof doc.byCurriculum !== 'object') {
    throw new Error('tour file is not version 1');
  }
  return doc;
}

/**
 * The entry for the course whose world the learner is in, or null. A course with no entry (held for a data fix,
 * or not in the file) simply has no tour slide or quiz; the rest of the first visit still runs.
 */
export function tourEntryFor(tour, curriculumId) {
  const code = curriculumId ? tour?.byCurriculum?.[String(curriculumId)] : null;
  const entry = code ? tour.courses?.[code] : null;
  if (!entry?.slide?.audio || !Array.isArray(entry?.quiz) || !entry.quiz.length) return null;
  return {code, ...entry};
}
